import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import "./project.css"


export default function Project() {


  
  
  let dataArr=[
    {id:1,image:"zapos3.jpg",title:"Zappos",discrip:"Zappos.com is an American online shoe and clothing retailer based in Las Vegas, Nevada, United States and products are Shoes, handbags, eyewear, accessories, clothing etc.",url:"https://cheerful-toffee-3caf61.netlify.app/" , giturl:"https://github.com/Gurjazz18/Zappos.com-clone",
    tech:"CSS,  HTML,   JAVASCRIPT"} ,

    {id:2,image:"shopq.jpeg",title:"ShopQmart",discrip:"ShopClues renamed as ShopQ_Mart it is an e-commerce market that connects sellers and buyers online and offers a trusted.",url:"https://shopqmart.vercel.app/",giturl:"https://github.com/SCjadhav21/Project_ShopQ_Mart",tech:"CSS,  EXPRESS,NODE-JS HTML, REACT,  CHAKRA,   REDUX, MONGO,"},

    {id:4,image:"hubspot.png",title:"Hubspot",discrip:"CRM platform that connects everything scaling companies need to deliver a best-in-class customer experience into one place and help businesses grow better every day.",url:"https://subtle-semifreddo-ade928.netlify.app/",giturl:"https://github.com/Gurjazz18/hubspot.com-Clone",tech:"CSS,   HTML, REACT-JS,  CHAKRA-LIBRARY,   REDUX,"},

    {id:3,image:"naukri.png",title:"Naukri",discrip:"Apply to millions of job opportunities across top companies, industries and locations on India's No.1 jo site. ",url:"https://630b219f95131e1a87ab9a47--dainty-cassata-354e69.netlify.app/#",giturl:"https://github.com/NandlalShah955/Naukri.com-Clone",tech:"CSS,  HTML,   JAVASCRIPT"},

   

   





]

  
  return (
   
    <div className='work-container'>
   
     
    <h1 className='project-heading'>Projects</h1>

    <div className='project-container'>

    {
      dataArr.map((elem)=>(

        <div className='project-card'>
          <img src={elem.image} alt="mytheresa" height="250px"/> 
           <h2 className='project-title'>{elem.title}</h2>
            <div className='pro-details'>
            <p >{elem.discrip} </p>

            <div className='pro-btn'>
           <a href={elem.url} target="_blank">
            <button className="btn">View</button></a>
           <a href={elem.giturl}  target="_blank"> 
            <button  className="btn">Source</button></a>
        
            </div>
            <h4 id='tectstack'>TECH-STACK   {":"}       {elem.tech}</h4>
         </div>
      
      </div>

      ))
    }

   

    </div>
      
    </div>
  )
}
